export const GET_donation_form = ({ donation_form }) => donation_form;
